import { NotificationType } from '@/src/app/components/Notification/types';
import type { ReactNode } from 'react';

export type Notification = {
  type: NotificationType;
  message: string | ReactNode;
  autoClose?: boolean;
  autoCloseDuration?: number;
  autoCloseOnUnmount?: boolean;
};

export function isNotificationItem(item: unknown): item is Notification {
  return item instanceof Object && 'message' in item && 'type' in item;
}
